import React, { useRef, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Node,
} from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import CustomViewFilters from '../../../components/ViewFilters';
import { Pager } from '../../../components';

import './style.scss';

const ViewArticleOverview = (props) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const viewIsLoaded = useRef(null);
  const { entities, pager, page, setCurrentPage, setFilters, filters: defaultFilters } = props;
  const totalPages = pager.get('total_pages');

  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        const y = ref.current.getBoundingClientRect().top + window.pageYOffset - 200;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const isLoading = useMemo(() => {
    return page !== pager.get('current_page');
  }, [page, pager]);

  const classes = classNames('View', 'ViewArticleOverview', {
    'ViewArticleOverview--loading': isLoading,
  });

  return (
    <div className={classes} ref={ref}>
      <Container>
        <CustomViewFilters
          viewId="recent_articles"
          display="overview"
          defaultFilters={defaultFilters}
          onUpdate={(filters) => setFilters(filters)}
        />
        {entities.size === 0 && <div>{ t('search.result_empty') }</div>}
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'ViewArticleOverview__item';
            return (
              <div key={`${uuid}:${langcode}`} className="col-12 col-sm-6 col-md-4">
                <div className={className}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="ViewArticleOverview__pager">
          <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setCurrentPage} />
        </div>
      </Container>
    </div>
  );
};

export default ViewArticleOverview;
